import i18n from "../../i18n"

import DestinationService from "../../services/api/DestinationService"
import { getFromUrl } from "../../helpers/utm"

const destinationService = new DestinationService()

export default {
  switchLang({ state, commit }) {
    const lang = state.lang === "fr" ? "en" : "fr"
    i18n.locale = lang
    commit("setLang", lang)
  },
  checkIsContestClosed({ commit }) {
    const now = new Date()
    if (process.env.VUE_APP_CONTEST_END_DATE < +now) {
      commit("setIsContestClosed", true)
    }
  },
  updateUTMs({ commit }) {
    const utms = {
      utm_source: getFromUrl("utm_source"),
      utm_campaign: getFromUrl("utm_campaign"),
      utm_medium: getFromUrl("utm_medium"),
      utm_content: getFromUrl("utm_content"),
      utm_term: getFromUrl("utm_term")
    }
    commit("setUTMs", utms)
  },
  async loadDestinations({ state, commit }) {
    if (state.destinations.length > 0) {
      return Promise.resolve(state.destinations)
    }
    const destinations = await destinationService.getDestinations()
    commit("setDestinations", destinations)
    return destinations
  }
}
